export default __webpack_public_path__ + "static/binance_coin-92643887cb735977d3b978a1e1bdf192.png";